export const EXPENSE_TYPE_ONGOING = "ongoing";
export const EXPENSE_TYPE_IRREGULAR = "irregular";

export function normalizeExpenseType(value) {
  const normalized = String(value ?? "").trim().toLocaleLowerCase();

  if (normalized === EXPENSE_TYPE_ONGOING) {
    return EXPENSE_TYPE_ONGOING;
  }

  if (normalized === EXPENSE_TYPE_IRREGULAR) {
    return EXPENSE_TYPE_IRREGULAR;
  }

  return String(value ?? "").trim();
}

export function getExpenseTypeTranslationKey(value) {
  const normalized = normalizeExpenseType(value);

  if (normalized === EXPENSE_TYPE_ONGOING) {
    return "ongoing";
  }

  if (normalized === EXPENSE_TYPE_IRREGULAR) {
    return "irregular";
  }

  return normalized;
}
